<ng-progress ngProgressRouter #appProgress/>
@if (!isAuthPage) {
  <braidsbook-header/>
}
<main [ngClass]="{'mt-[75px]': !isAuthPage}">
  <router-outlet></router-outlet>
</main>
@if (!isAuthPage) {
  <app-footer/>
}
<braidsbook-cart-drawer/>
<braidsbook-chat-panel/>
